/**
 * Header height constants for annual program detail page scroll calculations.
 * These values are used to offset scroll positions to account for the fixed header.
 */

/** Header height on mobile devices (width <= 1100px) in pixels */
export const PROGRAM_DETAIL_HEADER_HEIGHT_MOBILE = 70

/** Header height on desktop devices (width > 1100px) in pixels */
export const PROGRAM_DETAIL_HEADER_HEIGHT_DESKTOP = 140

/** Breakpoint width in pixels where header height changes */
export const PROGRAM_DETAIL_HEADER_BREAKPOINT = 1100
